/**
 * Const element
 * Iframe Login component
 * Display the iframe of Login
 */
/* Import section */
import React from "react"

/* Declaration function */
const Iframelogin= () => {
  return (
    <iframe title="login" name="login" width="285" height="250" src="https://platform.hellohealth.com/login/?stylesheet=user#login" scrolling="no" allowtransparency="no" marginheight="0" marginwidth="0" frameborder="0" class="userLoginFrame"></iframe>
  )
}

/* Export function */
export default Iframelogin
